angular.module('tasks')
    .controller('MenuUserGroupAutoselect', function ($scope, $cookies, Principal) {
        $scope.cookieKey = "group-autoselect-selected";

        $scope.$on('authenticationSuccess', () => getAccount());

        getAccount();

        function getAccount() {
            Principal.identity().then(account => {
                $scope.currentAccount = account;
                $scope.isAuthenticated = Principal.isAuthenticated;
                let saved = $cookies.getObject($scope.cookieKey);

                if ($scope.currentAccount === null) {
                    return;
                }

                if ($scope.currentAccount.groups.length === 1) {
                    $scope.changeGroup($scope.currentAccount.groups[0]);
                } else if (saved) {
                    let groupIndex = $scope.currentAccount.groups.map(e => e.id).indexOf(saved.id);

                    if (groupIndex > -1) {
                        $scope.changeGroup($scope.currentAccount.groups[groupIndex]);
                    } else {
                        $scope.changeGroup(null);
                    }
                }
            });
        }

        $scope.changeGroup = model => {
            if (model) {
                $scope.groupSelected = model;
                $cookies.putObject($scope.cookieKey, model);
            } else {
                delete $scope.groupSelected;
                $cookies.remove($scope.cookieKey);
            }
        };
    });
